import BimServicedList from 'modules/analytics/components/BimServicedList/BimServicedList';
import useBimActivityListData from 'modules/analytics/hooks/useBimActivityListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';

const BimServicedPage = () => {
    const { data: logs, isLoading } = useBimActivityListData();

    return (
        <PageTemplate>
            <PageHeading className="flex justify-between items-center">
                <div>BIM Activation</div>
            </PageHeading>

            <div>
                <BimServicedList isLoading={isLoading} cameras={logs} />
            </div>
        </PageTemplate>
    );
};

export default BimServicedPage;
